import styled from "styled-components";
import {LogoType, Person, PromptStyle, PromptTemplate, StyledBaseProps} from "@betrue/shared/interfaces";
import Card from "@mui/material/Card";
import {
  CardActionArea,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  Stack
} from "@mui/material";
import * as React from "react";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

interface LogoSettingsViewProps extends StyledBaseProps {
  principal: Person
  model: string
  handleModelChanged: (model) => void
  promptStyles: PromptTemplate[]
  selectedPromptTemplateId: string
  handleSelectedPromptTemplateId: (templateId: string) => void
  inputWeight: number
  setInputWeight: (weight) => void

}


export const LogoSettingsView = styled((props: LogoSettingsViewProps) => {


  return (

    <Grid className={props.className} container direction={'row'} spacing={3} justifyContent={'space-between'}
          alignContent={'center'}
          alignItems={'center'}>
      {props.principal ? (<Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Model</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={props.model}
            label="Age"
            MenuProps={
              {
                disableAutoFocus: true,
                disableEnforceFocus: true,
                disableRestoreFocus: true,
                disablePortal: true
              }
            }
            onChange={(e) => props.handleModelChanged(e.target.value)}
          >
            <MenuItem value={"sd_xl_base_1.0_0.9vae.safetensors"}>SDXL</MenuItem>
            <MenuItem value={"v1-5-pruned-emaonly.safetensors"}>V1.5</MenuItem>
          </Select>
          <Stack spacing={2} sx={{mb: 1}} alignItems="center" direction={'row'}>
            <Slider min={0}
                    max={2}
                    defaultValue={1}
                    step={0.01}
                    aria-label="inputWeight"
                    value={props.inputWeight}
                    onChange={(e, value) => props.setInputWeight(value)}/>
            <Divider sx={{height: 40, m: 0.5}} orientation="vertical"/>
            <div style={{margin: '5px'}}>
              {props.inputWeight}
            </div>

          </Stack>
        </FormControl>
      </Grid>) : ''}
      {props.promptStyles?.map(s => (<Grid item xs={4}>
        <Card key={s.label} className={(props.selectedPromptTemplateId === s.id ? 'selected-style' : '')}>
          <CardActionArea onClick={() => props.handleSelectedPromptTemplateId(s.id)}>
           <CardMedia sx={{height: 100}} title={s.label} component='img' image={s.logo}/>
            <CardContent className={'style-card'}>
              <Typography variant={'subtitle2'} component="div">
                {s.label}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>))}
    </Grid>
  )
})
  `
    & {
    }
  `
